import {makeStyles} from "tss-react/mui";
import {Box, Typography} from "@mui/material";

interface IStyleProps {
	outline?: IProps["outline"]
}

const useStyles = makeStyles<IStyleProps>()((theme, {outline}) => ({
	adminFieldContainer: {
		width: "100%",
		border: outline ? "1px solid " + theme.palette.grey[200] : "inherit",
		borderRadius: "5px",
		padding: outline ? "5px" : "0"
	},
	adminFieldContainerLabel: {
		fontWeight: 600,
		margin: "8px 0",
		"& span": {
			color: theme.palette.error.main
		}
	},
	error: {
		color: theme.palette.error.main
	}
}));

export interface IProps {
	children: JSX.Element | JSX.Element[],
	outline?: boolean,
	error?: string,
	required?: boolean
}

export const AdminFieldContainer = ({children, required, error, outline}: IProps): JSX.Element => {
	const {classes} = useStyles({outline});
	return (
		<Box>
			{/* <Typography className={classes.adminFieldContainerLabel}>{label}{required ? <span>*</span> : <></>}</Typography> */}
			<Box className={classes.adminFieldContainer}>
				{children}
			</Box>
			{error && <Typography className={classes.error}>{error}</Typography>}
		</Box>

	);
}